import type { HierarchyPointNode } from 'd3';
import type { TreeNode } from '../types';

// function for collapsing nodes
export function collapse(d: HierarchyPointNode<TreeNode>): void {
    if (d.children) {
        //d.data.children = expanded children
        d.data._children = d.children;
        d.data._children.forEach(collapse);
        d.children = null;
    }
}

// function for expanding nodes
export function expand(d: HierarchyPointNode<TreeNode>): void {
    if (d.data._children) {
        //d.data._children = collapes children
        d.children = d.data._children;
        d.data._children = null;
    }
}

// function to expand all nodes
export function expandAll(d: HierarchyPointNode<TreeNode>): void {
    if (d.data._children) {
        d.children = d.data._children;
        d.data._children = null;
    }
    const children = d.children ? d.children : d.data._children;
    if (children) {
        children.forEach(expandAll);
    }
}

// function to toggle children
export function toggleChildren(d: HierarchyPointNode<TreeNode>) {
    if (d.children) {
        collapse(d);
    } else if (d.data._children) {
        expand(d);
    }
    return d;
}
